import { useCallback, useState } from "react";
import DeleteClinic from "./DeleteClinic";
import ClinicDeleteError from "./DeleteClinicError";
import { InfoMessageType } from "src/SharedComponents/InfoBar/InfoBar";

interface IRemovelinicParams {
    clinicId: string;
    clinicName: string;
    updateClinics: () => void;
    onClose: () => void
}
const RemoveClinic: React.FC<IRemovelinicParams> = ({clinicId, clinicName, updateClinics, onClose }) => {
  const [showDeleteError, setShowDeleteError] = useState<boolean>(false);
  const DeleteClinicStatus = useCallback( (status: InfoMessageType) => {
    if (status === InfoMessageType.error) {
      setShowDeleteError(true);
    }
    if (status === InfoMessageType.success) {
      updateClinics();
      onClose();
    }
  },[onClose, updateClinics])
  return (
    <>
      {showDeleteError && <ClinicDeleteError onClose={onClose}/>}
      <DeleteClinic clinicId={clinicId} clinicName={clinicName} DeleteClinicStatus={DeleteClinicStatus} onClose={onClose} />
    </>
  );
};
    
export default RemoveClinic;